module.exports = __webpack_public_path__ + "img/mob2.ff945861.png";